<template>
  <div class="video-row-thumbnail">
    <div class="thumbnail" :class="{'loaded': isThumbnailLoaded}">

      <transition name="fade">
        <figure v-show="isThumbnailLoaded">
          <img
            v-if="url.length > 0"
            :src="url"
            @load="isThumbnailLoaded = true"
          />
        </figure>
      </transition>

      <div v-if="shouldShowLoadingIndicator">
        <hollow-dots-spinner
          :animation-duration="1000"
          :dot-size="7"
          :dots-num="3"
          color="#5b9fef"
        />
      </div>

      <div
        v-if="shouldShowUnavailableNotice"
        class="unavailable-notice"
      >
        Thumbnail<br/>
        Unavailable
      </div>

    </div>
  </div>
</template>

<script>
import {HollowDotsSpinner} from 'epic-spinners';

export default {
  name: "VideoRowThumbnail",
  components: {
    HollowDotsSpinner,
  },
  props: {
    isGeneratingThumbnail: Boolean,
    url: String,
  },
  data() {
    return {
      isThumbnailLoaded: false,
    };
  },
  computed: {
    shouldShowLoadingIndicator() {
      return this.isGeneratingThumbnail || (!this.isThumbnailLoaded && this.url.length > 0);
    },
    shouldShowUnavailableNotice() {
      return !this.isGeneratingThumbnail && this.url.length === 0;
    }
  },
}
</script>

<style scoped lang="scss">
  .video-row-thumbnail {
    .thumbnail {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 80px;
      height: 45px;
      border: 1px solid rgba(0, 0, 0, 0.125);

      flex: initial;
      margin-right: 16px;

      figure {
        width: 80px;
        height: 45px;
        margin: 0;
      }

      img {
        flex: initial;
        width: 80px;
        height: 45px;
      }
    }

    .thumbnail.loaded {
      border: none;
    }

    .unavailable-notice {
      color: #8091a5;
      font-size: 10px;
      text-align: center;
      line-height: 12px;
    }
  }
</style>
